export default __webpack_public_path__ + "static/media/banner.8f91c3a6.png";